/* eslint-disable no-template-curly-in-string */
import React, { FC } from "react";
import { DiscountIconSvg } from "../../../icons";
import {
  DiscountCategory,
  CheckoutOrderSummaryLocalizations,
} from "../../../../types/graphql/generated";
import { StyledDiscount, StyledDiscountDetails } from "./index.styled";
import { parseTemplateAsString } from "../../../../helpers/localization";

export interface DiscountDetails {
  amount: string;
  category: DiscountCategory;
}

interface DiscountsProps {
  discounts: DiscountDetails[];
  localization?: CheckoutOrderSummaryLocalizations | null;
}

export const Discounts: FC<DiscountsProps> = ({ discounts, localization }) => {
  const {
    bundleDiscountText = "${amount} bundle discount",
    bulkDiscountText = "${amount} bulk discount",
  } = localization || {};

  return (
    <>
      {discounts.map((discount, i) => {
        const { amount, category } = discount;
        if (
          [DiscountCategory.Subscription, DiscountCategory.Basic].includes(
            category
          )
        ) {
          return null;
        }

        let discountText = "";
        switch (discount.category) {
          case DiscountCategory.DynamicBundle:
            discountText = bundleDiscountText;
            break;
          case DiscountCategory.Tiered:
            discountText = bulkDiscountText;
            break;
          default:
          // no default
        }

        return (
          <StyledDiscount key={i}>
            <DiscountIconSvg />
            <StyledDiscountDetails>
              {parseTemplateAsString(discountText, { amount })}
            </StyledDiscountDetails>
          </StyledDiscount>
        );
      })}
    </>
  );
};
